module.exports = "<div gw-notes-list notes=\"notes\"\r\n     on-new-note=\"createAccountNote()\"\r\n     create-label=\"{{'gateway.views.account-detail.Note'|translate}}\"\r\n     empty-message=\"{{'gateway.views.account-detail.No notes associated with this activity'|translate}}\"\r\n     gw-loader=\"accountNotesPromise\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/views/account/notes.html
// module id = 782
// module chunks = 0